import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-option-meta',
    templateUrl: './option-meta.component.html',
    styleUrls: ['./option-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('option-meta')
export class OptionMetaComponent {
    model = input<any>();

    metaOption: any;

    formArray: FormArray<any> = new FormArray<any>([]);

    constructor() {
        effect(() => {
            const model = this.model();

            if (model) {
                if (model.type.data.label) {
                    this.setMetaOption(model.type.data);
                }

                model.meta?.formGroup.addControl('options', this.formArray);
                this.loadOptions();
            }
        });
    }

    onAddField() {
        const model = this.model();

        if (!this.metaOption) {
            this.setMetaOption(model.meta.formGroup.value);
        }
        if (!model.type.data.options) {
            model.type.data.options = [];
        }
        model.type.data.options.push({});
        this.formArray.push(new FormGroup({}));
        model.meta.formGroup.markAsDirty();
    }

    onDelete($event: any) {
        const model = this.model();
        const index = model.type.data.options.findIndex((x: any) => x === $event);
        model.type.data.options.splice(index, 1);
        this.formArray.removeAt(index);
        model.meta.formGroup.markAsDirty();
    }

    private loadOptions() {
        const model = this.model();
        const hasOptions = model.type?.data?.options?.length > 0;
        if (hasOptions) {
            for (const option of model.type.data.options) {
                this.formArray.push(
                    new FormGroup({}));
            }
        }
    }

    private setMetaOption(source: any) {
        this.metaOption = { label: { id: source.label, name: 'Option Label' }, value: { id: source.value, name: 'Option Value' } };
    }
}
